import React from 'react';
import PropTypes from 'prop-types';
import { InputGroupAddon as ReactstrapInputGroupAddon } from 'reactstrap';
import Isvg from 'react-inlinesvg';


export default class InputGroupAddon extends React.Component {
  static propTypes = {
    icon: PropTypes.string,
  };

  static defaultProps = {
    icon: undefined,
  };

  render(): React.ReactNode {
    return (
      <ReactstrapInputGroupAddon addonType="prepend">
        <div className="icon-container">
          <Isvg src={this.props.icon} />
        </div>
      </ReactstrapInputGroupAddon>
    );
  }
}
